<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="button-row">
  <button
    mat-raised-button
    color="primary"
    (click)="addVariable()"
    [disabled]="!canEdit"
    >
    Add Variable
  </button>
</div>

@if (variables$ | async; as variables) {
  <div>
    @if (variables.length) {
      <div class="d-flex flex-row flex-wrap gap-3">
        @for (item of variables; track trackByFn($index, item)) {
          <cas-variable
            [variable]="item"
            [canEdit]="canEdit"
          ></cas-variable>
        }
      </div>
    } @else {
      This Design doesn't have any Variables yet.
    }
  </div>
}
